import React, { Component, Fragment } from 'react';

import UserHeadingSession from './UserHeadingSession';
import InnerSubmenuWap from './HeaderWap/InnerSubmenuWap';
import { categoryIconsSubMenu } from '../../GapNewHeader/Header/svgIcons';
class ItemInnerMenuWap extends Component {
  render() {
    const { subMenu, menuIndex, shouldShowMenu, infoSession, handleLoginWithAuth0 } = this.props;

    return (
      <Fragment>
        <div className={'aligmentItems buttonSessionContainer borderButtonSession'}>
          {
            <UserHeadingSession
              customer={infoSession}
              handleLogin={handleLoginWithAuth0}
            />
          }
        </div>
        <InnerSubmenuWap
          handleClick={() => this.props.shouldShowSubMenu(this.props.categoriesLabel, true)}
          text={this.props.categoriesLabel}
          className="aditionalStyleForInnerSubmenu"
          icon={categoryIconsSubMenu}
        />
        <div className='liverpoolSubMenuContainer'>
        {
          subMenu.map(item => (
            <div key={`${menuIndex}-${item.label}`} className={'aligmentItems'}>
              <a
                className={`${'iconAligment'} ${'innerMenuSectionTitle'}`}
                href={item.url}
                onClick={e => shouldShowMenu(e, item.label)}
              >
                {item.icon}
                {/* <h1 className={`${innerMenuSectionTitle === item.heading ? 'activeLink' : ''}`}>{ item.title }</h1> */}
                <span>{item.label}</span>
              </a>
            </div>
          ))
        }
        </div>
      </Fragment>
    );
  }
}

export default ItemInnerMenuWap;

